import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_REQUEST_TEMPLATE, CREATE_REQUEST } from '../redux/action/types';
import { areaApi } from '../utils/api';
import { setGlobalErrorVisibility } from '../redux/action';

function* getRequestTemplate(action) {
  try {
    let response = yield call(() => areaApi.getRequestTemplate(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess(response.data);
    }
  } catch (err) {
    action.data.onError && action.data.onError();
    console.log(err);
  }
}

function* createRequest(action) {
  try {
    let response = yield call(() => areaApi.createRequest(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* requestsSaga() {
  yield takeLatest(GET_REQUEST_TEMPLATE, getRequestTemplate);
  yield takeLatest(CREATE_REQUEST, createRequest);
}

export default requestsSaga;
